module.exports = __webpack_public_path__ + "static/img/8.d0b07dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/8.png
// module id = Kq2T
// module chunks = 1